import * as React from "react";
import { Component } from "react";
import { IDropDownItem } from "../models/IDropdownItem";
import "./SimpleSelect.css";

interface IProps {
    Items: IDropDownItem[];
    Title: string;
    OnItemSelected?: (selectedItem?: IDropDownItem) => void;
    NoAvatar?: boolean;
}

interface IState {
    DropDownOpen: boolean;
    HighLightedIndex: number;
}


export class SimpleSelectComponent extends Component<IProps, IState> {


    constructor(props) {
        super(props);

        this.state = {
            DropDownOpen: false,
            HighLightedIndex: 0,
        };
    }


    public render() {
        const { Title, NoAvatar } = this.props;
        return (
            <div
                className="select-container select-container--simple"
                tabIndex={-1}
            >
                <div
                    className="container"
                    onClick={this.ToggleDropdown}>
                    {NoAvatar ?
                        null
                        :
                        <div className="container__avatar-icon-wrapper">
                            <div className="container__avatar-icon" />
                        </div>
                    }

                    <div className="container__title">{Title}</div>
                    <div className="container__chevron" />
                </div>

                {this.RenderDropDown()}

            </div>
        );
    }

    private ToggleDropdown = (e) => {
        this.setState({
            DropDownOpen: !this.state.DropDownOpen
        });
    }

    private RenderDropDown = () => {
        if (!this.state.DropDownOpen) {
            return null;
        }

        return (
            <div className="dropdown dropdown--simple">
                <ul
                    className="dropdown-list select-list">{this.RenderDropDownItems()}</ul>
            </div>
        );
    }

    private ItemSelectedHandler = (item) => {
        if (this.props.OnItemSelected) {
            this.props.OnItemSelected(item);
            this.ToggleDropdown(false)
        }
    }

    private RenderDropDownItems = () => {
        const { Items, OnItemSelected } = this.props;
        const { HighLightedIndex } = this.state;

        return Items.map((item, index) => (
            <li
                key={index}
                onClick={item.OnClick ? item.OnClick : OnItemSelected ? this.ItemSelectedHandler.bind(this, item) : null}
                className={`dropdown-list__item ${Items.indexOf(item) === HighLightedIndex
                    ? "dropdown-list__item--highlighted"
                    : ""
                    }
                `}
            >
                <div className={`dropdown-list__item--${item.Icon}`} />
                <span className="dropdown-list__item--bold">{item.Value}</span>
            </li>
        ));

    }
}



// WEBPACK FOOTER //
// ./src/controls/SimpleSelect.tsx